import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Barre gold is the action color on this page (5:1+ against plum).
 * Coral is reserved for tension (pain marks, price rise, the "without" column).
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-5 text-lg sm:text-xl rounded-full min-h-[64px]' : 'px-5 py-3 text-sm rounded-full';
  return <a href={href} className={`inline-flex w-full items-center justify-center text-center gap-2 bg-gold hover:bg-gold-hover text-gold-ink font-semibold tracking-wide shadow-card hover:shadow-lift transition-[background-color,box-shadow,transform] duration-200 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 ${sizing} ${className}`} data-id="element-80" data-mp="lkxrkeh1rko5">
      {children}
    </a>;
}